import { render, staticRenderFns } from "./TheModalAccountIsPending.vue?vue&type=template&id=23414c27&"
import script from "./TheModalAccountIsPending.vue?vue&type=script&lang=js&"
export * from "./TheModalAccountIsPending.vue?vue&type=script&lang=js&"
import style0 from "./TheModalAccountIsPending.vue?vue&type=style&index=0&id=23414c27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports